export default "__VITE_ASSET__B4uE44ZU__"